type FilterableInvoice = {
  invoice_status: string;
  client_id: string;
  total_amount: number;
  line_items: { product_id: string }[];
};
export type InvoiceFilters = { statuses: string[]; clients: string[]; products: string[]; minValue: number | ''; maxValue: number | '' };
export function matchesInvoiceFilters(invoice: FilterableInvoice, filters: InvoiceFilters, allowValues: boolean): boolean {
  return (!filters.statuses.length || filters.statuses.includes(invoice.invoice_status))
    && (!filters.clients.length || filters.clients.includes(invoice.client_id))
    && (!filters.products.length || invoice.line_items.some(item => filters.products.includes(item.product_id)))
    && (!allowValues || filters.minValue === '' || invoice.total_amount >= filters.minValue)
    && (!allowValues || filters.maxValue === '' || invoice.total_amount <= filters.maxValue);
}
